import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { UserAPIModelsERoles } from 'user-ts-ng-client';

import { AccessControlService } from '@core/auth/access-control.service';
import { AuthService } from '@core/auth/auth.service';
import { UserDataService } from '@core/auth/user-data.service';

export const organizationAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const userDataService = inject(UserDataService);
  const authService = inject(AuthService);
  const accessControlService = inject(AccessControlService);

  const userRole = authService.getRole();

  if (userRole === UserAPIModelsERoles.GlobalAdmin) {
    return true;
  }

  if (accessControlService.isInternalSrmContributorReadOnly()) {
    return true;
  }

  const requestedOrgId = route.paramMap.get('id');
  const userOrgId = userDataService.getOrganizationId();

  if (requestedOrgId === userOrgId) {
    return true;
  }

  void router.navigate(['/dashboard']);

  return false;
};
